import { createAsyncThunk } from '@reduxjs/toolkit';

import { IDeliveryNote } from 'commons/types';
import { defaultActionProcess } from 'commons/utils/defaultActionProcess';
import { RootReducerInterface } from 'redux-stores/reducers';
import {
  setDeliveryNotes,
  setPriorityList,
  setSelectedDeliveryNote,
  setTotalDeliveryNotes,
} from 'redux-stores/reducers/deliveryNoteReducer';
import { AppDispatch } from 'redux-stores/store';
import { swiperxWmsApiDeliveryNote } from 'services/apis/SwipeRxWmsApiDeliveryNote';

export const printDeliveryNoteAction = createAsyncThunk<
  IDeliveryNote | undefined,
  string
>(
  'deliveryNote/printDeliveryNoteAction',
  async (awbNumber, { dispatch, getState }) => {
    return defaultActionProcess(async () => {
      await swiperxWmsApiDeliveryNote.printDeliveryNote(awbNumber);
      const data =
        await swiperxWmsApiDeliveryNote.getDeliveryNoteByAwbNumber(awbNumber);
      const { selectedDeliveryNote } = (getState() as RootReducerInterface)
        .deliveryNote;
      if (selectedDeliveryNote?.awb_number === awbNumber) {
        dispatch(setSelectedDeliveryNote(data));
      }
      return data;
    }, dispatch as AppDispatch);
  },
);

export const getDeliveryNoteDetailAction = createAsyncThunk(
  'deliveryNote/getDeliveryNoteDetailAction',
  async (awbNumber: string, { dispatch }) => {
    return defaultActionProcess(async () => {
      const data =
        await swiperxWmsApiDeliveryNote.getDeliveryNoteByAwbNumber(awbNumber);
      dispatch(setSelectedDeliveryNote(data));
    }, dispatch as AppDispatch);
  },
);

export const getDeliveryNotePriorityListAction = createAsyncThunk(
  'deliveryNote/getDeliveryNotePriorityListAction',
  async (_, { dispatch }) => {
    return defaultActionProcess(async () => {
      const priorities = await swiperxWmsApiDeliveryNote.getPriorityList();
      dispatch(setPriorityList(priorities));
    }, dispatch as AppDispatch);
  },
);

export const getDeliveryNoteListAction = createAsyncThunk(
  'deliveryNote/getDeliveryNoteListAction',
  async (params: { searchParams?: URLSearchParams }, { dispatch }) => {
    const { searchParams } = params;
    const queries: Record<string, string> = {};
    searchParams?.forEach((value, key) => {
      queries[key] = value;
    });

    return defaultActionProcess(async () => {
      const response =
        await swiperxWmsApiDeliveryNote.getDeliveryNoteList(queries);
      dispatch(setDeliveryNotes(response.data));
      dispatch(setTotalDeliveryNotes(response.total));
    }, dispatch as AppDispatch);
  },
);
